module.exports = __webpack_public_path__ + "static/media/plug2.4a4458cd.svg";